import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import store from './services/store/store'
import { MantineProvider } from '@mantine/core'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
	<MantineProvider
		withGlobalStyles
		withNormalizeCSS
		theme={{
			colorScheme: 'light',
			breakpoints: {
				xs: '36em',
				sm: '48em',
				md: '62em',
				lg: '75em',
				xl: '88em',
			},
		}}
	>
		<Provider store={store}>
			<App />
		</Provider>
	</MantineProvider>
)
